import React from 'react';
import {Input, Icon, Tag,Tooltip,notification} from 'antd';
import {connect} from 'react-redux'
import { slideUpdateInitiated, slideUpdateSuccess, slideUpdateFailed } from '../../action/slide.update.action';
import axios from 'axios';
import {message} from 'antd';
import {AuthHeader} from '../../helper/auth.token'
var querystring = require('querystring');


class EditableTagGroup extends React.Component {
    state = {
        tags: this.props.tag,
        inputVisible: false,
        inputValue: '',
    };

    handleClose = (removedTag) => {
        const tags = this.state.tags.filter(tag => tag !== removedTag);
        this.setState({ tags });
        this.removeSlideTag(removedTag);
    }
    openNotification = (value) => {
        notification.open({
          message: value,
          placement :'bottomRight'
        //   description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        });
        notification.config({
            placement: 'bottomRight',
          });
      };


    removeSlideTag= (removedTag) => {
        let url = `/api/remove_slide_tag/`;
        console.log("Tag", removedTag);
        let val = {"title": removedTag, "slide_id" : this.props.morphle_id};
        console.log("Data", val);
        axios.post(url, querystring.stringify(val), {headers: {Authorization : AuthHeader()}})
            .then(response => {
            if(response.status === 200 || response.status === 301 || response.status === 302) {
                this.props.dispatch(slideUpdateSuccess(response));
                this.openNotification('Slide Update Successful')
            }
            else if(response.status === 403 || response.status === 401 || response.status === 400) {
                this.props.dispatch(slideUpdateFailed(response));
                this.openNotification('Slide Update Failed')
            }
        })
            .catch(err =>{
                this.props.dispatch(slideUpdateFailed(this.props.slide_id, err));
        });
    }

    showInput = () => {
        this.setState({ inputVisible: true }, () => this.input.focus());
    }

    handleInputChange = (e) => {
        this.setState({ inputValue: e.target.value });
    }

    addSlideTag= () => {
        const {inputValue}  = this.state;
        let { tags } = this.state;
        let stripped = '#' + inputValue.toString().replace('#', '').replace(' ', '');
        console.log(stripped);
        if (stripped && tags.indexOf(stripped) === -1) {
            tags = [...tags, stripped];
        }

        this.props.dispatch(slideUpdateInitiated());
        let url = `/api/add_slide_tag/`;
        let val = {"title": stripped, "slide_id" : this.props.morphle_id};
        axios.post(url, querystring.stringify(val), {headers: {Authorization : AuthHeader()}})
            .then(response => {
            if(response.status === 200 || response.status === 301 || response.status === 302) {
                this.props.dispatch(slideUpdateSuccess(this.props.slide_id, response));
                message.success('Slide Update Successful', 2.5);
            }
            else if(response.status === 403 || response.status === 401 || response.status === 400) {
                this.props.dispatch(slideUpdateFailed(this.props.slide_id, response));
                message.error('Slide Update Failed', 2.5);
            }
        })
            .catch(err =>{
                this.props.dispatch(slideUpdateFailed(this.props.slide_id, err));
        });
        this.setState({
            tags,
            inputVisible: false,
            inputValue: '',
        });
    }

    saveInputRef = input => this.input = input

    render() {
        const { tags, inputVisible, inputValue } = this.state;
        return (
        <div>
            {tags.map((tag, index) => {
            const isLongTag = tag.length > 20;
            const tagElem = (
                <Tag key={tag} closable='true' onClose={() => this.handleClose(tag)}>
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
            );
            return isLongTag ? <Tooltip title={tag} key={tag}>{tagElem}</Tooltip> : tagElem;
            })}
            {inputVisible && (
            <Input
                ref={this.saveInputRef}
                type="text"
                size="small"
                style={{ width: 78 }}
                value={inputValue}
                onChange={this.handleInputChange}
                onBlur={this.addSlideTag}
                onPressEnter={this.addSlideTag}
            />
            )}
            {!inputVisible && this.props.edit && (
            <Tag
                onClick={this.showInput}
                style={{ background: '#fff', borderStyle: 'dashed' }}
            >
                <Icon type="plus" /> New Tag
            </Tag>
            )}
        </div>
        );
    }
}


const mapStateToProps = (state) => {
    return{
        loginStatus :  state.loginAlerts.loginStatus
    }
}

export default connect(mapStateToProps)(EditableTagGroup)